import { useEffect } from 'react'
import GlobalStyles from '@/styles/global'
import LogisticRoutes from './router'
import { MenuProvider } from './context/MenuContext'
import { ScreenLockProvider } from './context/ScreenLock'
import { ActionProvider } from './context/ActionContext'
import { TableDataProvider } from './context/TableDataContext'
import { CustomFilterProvider } from './context/CustomFilterContext'
import { PermissionProvider } from './context/PermissionContext'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Bounce, ToastContainer } from 'react-toastify'

ChartJS.register(
  CategoryScale,
  ChartDataLabels,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)
function App() {
  useEffect(() => {
    if (window.location.pathname === '/') {
      window.location.href = '/login'
    }
  }, [])

  return (
    <>
      <GlobalStyles />
      <ScreenLockProvider>
        <PermissionProvider>
          <MenuProvider>
            <CustomFilterProvider>
              <TableDataProvider>
                <ActionProvider>
                  <LogisticRoutes />
                </ActionProvider>
              </TableDataProvider>
            </CustomFilterProvider>
          </MenuProvider>
        </PermissionProvider>
      </ScreenLockProvider>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
        className="custom-toast-container"
      />
    </>
  )
}

export default App
